import { memo as Memo } from 'react'

//* Components
import { Page, Container } from 'components/common'
import ProfileTopBar from './topBar'
import ProfileLeftBar from './LeftBar'
import ProfileRightBar from './rightBar'

//* Style
import ProfileStyle from 'styles/pages/ProfileStyle'

const ProfileMain = Memo(({ isMyProfile, profile }) => {
    return (
        <ProfileStyle>
            <Page className={'profile'}>
                <ProfileTopBar profile={profile} />
                <Container className={`flexBox profileCont FlexBoxContainer`}>
                    <div className={'profilePageCont flexBox'}>
                        <ProfileLeftBar
                            profile={profile}
                            isMyProfile={isMyProfile}
                        />
                        <ProfileRightBar
                            profile={profile}
                            isMyProfile={isMyProfile}
                        />
                    </div>
                </Container>
            </Page>
        </ProfileStyle>
    )
})

export default ProfileMain
